var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMobileFilterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    focusable: "false",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A202C",
    d: "M19.6667 7H21.7778V9.1106H26V11.2217H21.7778V13.3333H19.6667V11.2217V9.1106V7ZM17.5561 11.2217V9.1106H7.00051L7.00051 11.2217H17.5561ZM26 17.555V15.4439H15.4444V17.555H26ZM17.5566 19.6667H15.4455V26H17.5566V23.8884H26.0015V21.7773H17.5566V19.6667ZM11.2227 13.3333H13.3338V19.6667H11.2227V17.555H7.00026V15.4439H11.2227V13.3333ZM13.3333 21.7773V23.8884H7V21.7773H13.3333Z"
  })));
}

export default SvgMobileFilterIcon;